var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-modals" },
    [
      _c(
        "modal",
        {
          attrs: {
            name: "menu-images-modal",
            adaptive: true,
            width: "100%",
            "max-width": 580,
            height: "auto"
          },
          on: {
            opened: function($event) {
              _vm.modalOpen = true
            },
            closed: function($event) {
              return _vm.closedModal()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "close-button",
              on: {
                click: function($event) {
                  return _vm.closeModal("menu-images-modal")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          ),
          _vm._v(" "),
          _vm.modalOpen && _vm.activeModal.acf_fc_layout == "images"
            ? _c(
                "flickity-slider",
                {
                  ref: "slider",
                  staticClass: "images-modal-slider",
                  attrs: { options: _vm.sliderOptions }
                },
                _vm._l(_vm.activeModal.images, function(image) {
                  return _c("div", { staticClass: "carousel-cell" }, [
                    _c("img", { attrs: { src: image.sizes.large } }),
                    _vm._v(" "),
                    image.caption
                      ? _c("div", { staticClass: "caption" }, [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(image.caption) }
                          })
                        ])
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "menu-video-modal",
            adaptive: true,
            width: "100%",
            "max-width": 580,
            height: "auto"
          },
          on: {
            opened: function($event) {
              _vm.modalOpen = true
            },
            closed: function($event) {
              return _vm.closedModal()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "close-button",
              on: {
                click: function($event) {
                  return _vm.closeModal("menu-video-modal")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          ),
          _vm._v(" "),
          _vm.activeModal.acf_fc_layout == "video"
            ? _c("div", {
                staticClass: "video-embed",
                domProps: { innerHTML: _vm._s(_vm.activeModal.video) }
              })
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/MenuModals.vue?vue&type=template&id=2ed1e97a&
// module id = 450
// module chunks = 0